const POST_DRAG_FLUSH_DELAY_MS = 1500;

const activeDragIds = new Set<string>();
const pendingRefetches = new Map<string, () => void | Promise<void>>();
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function flushPendingRefetches(): void {
  if (activeDragIds.size > 0 || pendingRefetches.size === 0) return;
  const refetches = Array.from(pendingRefetches.values());
  pendingRefetches.clear();
  for (const refetch of refetches) {
    refetch();
  }
}

function scheduleFlush(): void {
  if (flushTimer !== null) {
    clearTimeout(flushTimer);
  }
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushPendingRefetches();
  }, POST_DRAG_FLUSH_DELAY_MS);
}

export function beginLinesetDrag(dragId: string): void {
  activeDragIds.add(dragId);
  if (flushTimer !== null) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
}

export function endLinesetDrag(dragId: string): void {
  activeDragIds.delete(dragId);
  if (activeDragIds.size === 0 && pendingRefetches.size > 0) {
    scheduleFlush();
  }
}

export function isLinesetDragActive(): boolean {
  return activeDragIds.size > 0;
}

export function deferRefetchUntilDragEnds(
  key: string,
  refetch: () => void | Promise<void>
): void {
  pendingRefetches.set(key, refetch);
}
